import { createContext, useContext, type ReactNode } from 'react';
import type { AuthContextValue, ProviderConfig } from './types';
import { MagicLinkProvider } from './magic-link';
import { EntraProvider } from './entra';

const AuthContext = createContext<AuthContextValue | null>(null);

interface Props {
  config: ProviderConfig;
  children: ReactNode;
}

export function AuthProvider({ config, children }: Props) {
  if (config.kind === 'supabase') {
    return (
      <MagicLinkProvider config={config.config} context={AuthContext}>
        {children}
      </MagicLinkProvider>
    );
  }
  return (
    <EntraProvider config={config.config} context={AuthContext}>
      {children}
    </EntraProvider>
  );
}

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth() must be called inside <AuthProvider/>.');
  }
  return ctx;
}

// Exported so the providers can publish into the same context the hook reads.
export { AuthContext };
